import React from "react";

const OurFields = () => {
  const fields = [
    "التنمية الاجتماعية",
    "التحول الرقمي والتكنولوجيا",
    "تنمية قدرات الشباب",
    "تمكين المرأة",
    "المجال الصحي",
    "التنمية الاقتصادية",
    "البيئة وحماية الموارد الطبيعية",
    "التعليم والمبادرات الثقافية",
    "حقوق الإنسان",
    "التنمية الرياضية",
    "التنمية السياحية والثقافية",
    "الإعلام والتوعية",
    "التعاون الدولي",
  ];

  return (
    <section id="jobs" style={styles.section}>
      <h2 style={styles.title}>مجالات عملنا</h2>
      <div style={styles.line}></div>

      <div style={styles.grid}>
        {fields.map((field, index) => (
          <div key={index} style={styles.card}>
            <div style={styles.icon}></div>
            <p style={styles.text}>{field}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#ffffff",
    color: "#0a0a0a",
    padding: "80px 20px",
    textAlign: "center",
  },
  title: {
    fontSize: "2.3rem",
    color: "#004aad", // الأزرق الأساسي
    marginBottom: "10px",
    fontWeight: "700",
  },
  line: {
    width: "90px",
    height: "3px",
    backgroundColor: "#004aad",
    margin: "0 auto 50px",
    borderRadius: "2px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "25px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  card: {
    background: "#f7f9fc",
    border: "1px solid rgba(0, 74, 173, 0.2)",
    borderRadius: "14px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "12px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    boxShadow: "0 3px 10px rgba(0, 0, 0, 0.05)",
  },
  cardHover: {
    transform: "translateY(-5px)",
    boxShadow: "0 6px 15px rgba(0, 74, 173, 0.15)",
  },
  icon: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: "#004aad",
    flexShrink: 0,
  },
  text: {
    fontSize: "1.1rem",
    color: "#002b60",
    fontWeight: "500",
    margin: 0,
  },
};

export default OurFields;
